<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" 
        variant="primary" 
        size="sm"
        @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
      <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
      <b-form>
        <b-form-group
          label="Nombre"
          label-for="nombre"
          :label-cols="labelCols"
          description="Nombre Comercial / Razón Social"
          horizontal>
          <b-form-input 
            id="nombre" 
            v-model="filtro.nombre" 
            type="text">
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="Nro.Documento"
          label-for="documentoNumero"
          :label-cols="labelCols"
          description="Código de identificación tributaria (CUIT, CIF, TIN\EIN, etc)"
          horizontal>
          <b-form-input 
            id="documentoNumero" 
            v-model="filtro.documentoNumero" 
            type="text">
          </b-form-input>
        </b-form-group>
        <b-form-group
          label-for="inactivo"
          :label-cols="labelCols">
          <b-form-checkbox 
              id="inactivo"
              v-model="filtro.incluirInactivos"
              value= true
              unchecked-value= false>
              Incluir Inactivos
          </b-form-checkbox>
        </b-form-group>
      </b-form>

    <div class="footer">
      <b-button size="sm" variant="primary" class="footer-button"
        @click.prevent="filtrar">Filtrar</b-button>
      <b-button size="sm" variant="primary" class="footer-button" 
        @click.prevent="limpiarFiltro">Limpiar</b-button>
    </div>

    </b-collapse>
    <!--
    <div slot="footer" class="footer" v-if="showOpcionesFiltro">
      <b-button size="sm" variant="primary" class="footer-button"
        @click.prevent="filtrar">Filtrar</b-button>
      <b-button size="sm" variant="primary" class="footer-button" 
        @click.prevent="limpiarFiltro">Limpiar</b-button>
    </div>
    -->
  </b-card>  
</template>

<script>
export default {
  components: {
  },
  props: {
    nombre: {
      type: String,
      default: ''
    },
    documentoNumero: {
      type: String,
      default: ''
    },
    incluirInactivos: {
      type: Boolean,
      default: Boolean(false)
    },
  },
  data() {
    return {
      filtro: {
        nombre: '',
        documentoNumero: '',
        incluirInactivos: Boolean(false),
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2
    }
  },
  created() {
      this.filtro.nombre = this.nombre;
      this.filtro.documentoNumero = this.documentoNumero;
      this.filtro.incluirInactivos = this.incluirInactivos;
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.nombre = '';
      this.filtro.documentoNumero = '';
      this.filtro.incluirInactivos = Boolean(false);
    },
  },
}
</script>

<style>
</style>
